import { render, staticRenderFns } from "./BizBusinessinfoProjectForm.vue?vue&type=template&id=2ea30851&"
import script from "./BizBusinessinfoProjectForm.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports